import React from 'react';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { COLOR } from 'utils/colors';

import Dialog from 'components/Dialog';
import dialogStyles from 'components/Dialog/style';
import LocalizedText from 'components/LocalizedText';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './stlyes';

type Props = {
    visible: boolean;
    closeDialog: () => void;
};

const { SETTINGS_FORGOT_PIN_OK } = LANGUAGE_KEYS;

const ForgotPin = ({ visible, closeDialog }: Props) => {
    const { t } = useTranslation();

    return (
        <Dialog
            visible={visible}
            style={dialogStyles.nonTransparentDialog}
            title="SETTINGS_FORGOT_PIN_CODE"
            DescriptionComponent={() => (
                <Text
                    category={ETextCategory.body1}
                    color={ETextColor.light_grey}
                    style={[dialogStyles.description, dialogStyles.text]}
                >
                    <LocalizedText textKey="SETTINGS_FORGOT_PIN_TEXT" />
                </Text>
            )}
            revertButtons
            onRequestClose={closeDialog}
            actionButtonOnPress={closeDialog}
            actionButtonTitle={t(SETTINGS_FORGOT_PIN_OK)}
            actionButtonAccessibilityLabel={t(SETTINGS_FORGOT_PIN_OK)}
            actionButtonTextStyle={styles.buttonText}
            actionButtonFillColor={COLOR.primary}
        />
    );
};

export default ForgotPin;
